module.exports = __webpack_public_path__ + "img/wifi-off.df8d4764.svg";